export function init(){
    
    $('#profile_update_profile_image .profile_image_preview').click(function(){
        $('#profile_update_profile_image input[name="profile_image"]').trigger('click');
    });

}

export function reset_password_form(){
    $('#profile_update_password input').val('');
}

export function update_profile(params){

    if(
        typeof params != 'undefined' 
        && typeof params.user != 'undefined'
    ){

        const user = params.user;

        $('.user-panel .info .name').html(user.name + (user.surname != null ? ' ' + user.surname : ''));
        $('.user-panel .info .surname').html(user.surname);
        $('.user-panel .info .email').html(user.email);

        if(user.locale != window._locale){
            document.location.href = document.location.href;
        }

    }

}

export function update_profile_image(params){

    if(
        typeof params != 'undefined' 
        && typeof params.preview != 'undefined'
        && typeof params.thumb != 'undefined'
    ){

        $('.profile_image_thumb').attr('src', params.thumb);
        $('.profile_image_preview').attr('src', params.preview);

        let blank = params.blank || false;
        if(!blank){
            $('[type="submit"][name="profile_delete_profile_image"]').removeClass('d-none');
        } else {
            $('[type="submit"][name="profile_delete_profile_image"]').addClass('d-none');
        }

    }

    $('#profile_update_profile_image input[name="profile_image"]').val('');
    $('#profile_update_profile_image input[name="profile_image"]').closest('.custom-file').find('label').html('');

}